import { render, staticRenderFns } from "./dialog-confirm-with-inner-icon.mpx?vue&type=template&id=05f71df8&isComponent&outputPath=components%2Fdialog-confirm-with-inner-iconc4f61212%2Findex"
import script from "./dialog-confirm-with-inner-icon.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fdialog-confirm-with-inner-iconc4f61212%2Findex"
export * from "./dialog-confirm-with-inner-icon.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fdialog-confirm-with-inner-iconc4f61212%2Findex"
import style0 from "./dialog-confirm-with-inner-icon.mpx?vue&type=style&index=0&id=05f71df8&prod&lang=stylus&mpxStyleOptions=%7B%22mid%22%3A%22_c4f61212%22%7D&isComponent&outputPath=components%2Fdialog-confirm-with-inner-iconc4f61212%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports